module.exports = __webpack_public_path__ + "img/1536517098.a8db8df1.jpg";